import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'inmateStatusClass', standalone: true })
export class InmateStatusClassPipe implements PipeTransform {
  transform(status: string | undefined): string {
    const s = (status || '').trim().toLowerCase();
    if (!s.includes('inactive') && (s === 'active' || s === 'a' || (/\bactive\b/.test(s) && s.includes('inmate')) || s.includes('custody'))) {
      return 'status-active';
    }
    if (s === 'terminated' || s === 't' || s.includes('released') || s.includes('discharged')) {
      return 'status-released';
    }
    if (s.includes('parole') || s.includes('probation') || s.includes('supervision')) {
      return 'status-supervision';
    }
    return 'status-neutral'; // unmapped — do not assume active/green
  }
}